import {
    course_assignNewMedalByMerging_Api,
    course_copyCourse_Api,
    course_createAllResultForCourse_Api,
    course_createCourse_Api,
    course_deleteCourse_Api,
    course_editCourse_Api,
    course_grantCertificateToStudentInCourse_Api,
    course_revokeCertificateFromStudentInCourse_Api,
} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {createNotification, NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {bindQueryParams} from "../../functions/routerHelper";
import {showConfirmDialog, showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {VscChecklist} from "react-icons/vsc";
import {TbCertificate, TbCertificateOff} from "react-icons/tb";
import {MaterialTypes} from "../../enums";

export const useCourseApi = ({
                                 owner_id,
                                 owner_type,
                                 autoRefresh = true,
                             }) => {
    const t = useTranslate()

    const [refreshKey, setRefreshKey] = useState()

    const onError = notifyOnError(t)

    const onRefresh = () => {
        if (autoRefresh) {
            setRefreshKey(Date.now())
        }
    }


    const {handleAsyncAction: onCourseCreate} = useAsyncAction({
        apiInfo: course_createCourse_Api,
        query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: onCourseUpdate} = useAsyncAction({
        apiInfo: course_editCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: grantCertificateToStudentInCourse} = useAsyncAction({
        apiInfo: course_grantCertificateToStudentInCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: revokeCertificateFromStudentInCourse} = useAsyncAction({
        apiInfo: course_revokeCertificateFromStudentInCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: issueThirdCertificateIfEligible} = useAsyncAction({
        apiInfo: course_assignNewMedalByMerging_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: onCourseUpdateResultAll} = useAsyncAction({
        apiInfo: course_createAllResultForCourse_Api,
        onError,
        onSuccess: () => {
            // successNotify(NotificationActionTypes.CREATE, t)
            createNotification({
                action: NotificationActionTypes.CREATE,
                params: {
                    message: 'Grade Synthesis Completed',
                    description: 'Student gradebooks have been successfully aggregated. For details, please navigate to \"Academic Results\" within the Course Students section.'
                },
                translate: t,
                type: MaterialTypes.SUCCESS,
            })
            onRefresh()
        },
    })

    const {handleAsyncAction: onCourseDuplicate} = useAsyncAction({
        apiInfo: course_copyCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: onCourseDelete} = useAsyncAction({
        apiInfo: course_deleteCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
        },
    })

    const confirmCourseDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete course',
                message: 'are you sure you want to delete this course',
                onOk: () => {
                    onCourseDelete({}, {id})
                },
            })
        }
    }
    const confirmResultUpdateAll = (id) => {
        if (id) {
            showConfirmDialog({
                icon: <VscChecklist className="text-red-500 anticon"/>,
                translate: t,
                title: 'Execute Grade Synthesis Process',
                message: 'This action will scan the student list and aggregate scores by subject to provide the latest results. Are you sure you want to proceed?',
                onOk: () => {
                    onCourseUpdateResultAll({}, {course_id: id})
                },
            })
        }
    }
    const confirmGrantCertificateToStudentInCourse = (id) => {
        if (id) {
            showConfirmDialog({
                icon: <TbCertificate className="text-green-500 anticon"/>,
                translate: t,
                title: 'grant to all students',
                onOk: () => {
                    grantCertificateToStudentInCourse({}, {id: id})
                },
            })
        }
    }
    const confirmRevokeCertificateFromStudentInCourse = (id) => {
        if (id) {
            showConfirmDialog({
                icon: <TbCertificateOff className="text-red-500 anticon"/>,
                translate: t,
                title: 'revoke all from students',
                onOk: () => {
                    revokeCertificateFromStudentInCourse({}, {id: id})
                },
            })
        }
    }


    return {
        onCourseCreate, onCourseUpdate,
        grantCertificateToStudentInCourse, revokeCertificateFromStudentInCourse, issueThirdCertificateIfEligible,
        onCourseUpdateResultAll, onCourseDuplicate, onCourseDelete,
        confirmCourseDelete, confirmResultUpdateAll,
        confirmGrantCertificateToStudentInCourse, confirmRevokeCertificateFromStudentInCourse,
        refreshKey
    }
}
